export default __webpack_public_path__ + "static/your-story-3a59048221ee53f7c624b62fe92cd7ce.png";